import Route, { ROUTE_COLOR_SUCCESS } from "@rio-cloud/rio-uikit/Route";
import { getRandomValueToForceRerender } from "../functions/getRandomValueToForceRerender";
import { IRouteSegment } from "../interfaces/IRouteSegment";

export const AutonomySegments = ({ segments }: { segments: IRouteSegment[] }) => {
  const mapSegments = segments.map((segment) => {
    return (
      <Route
        key={getRandomValueToForceRerender()}
        positions={segment.points}
        isRouteAlternative={false}
        hasArrows={true}
        style={{
          color: ROUTE_COLOR_SUCCESS,
        }}
      />
    );
  });
  return <>{mapSegments}</>;
};
